import { render, staticRenderFns } from "./realTimeGender.vue?vue&type=template&id=47fd984a&scoped=true"
import script from "./realTimeGender.vue?vue&type=script&lang=js"
export * from "./realTimeGender.vue?vue&type=script&lang=js"
import style0 from "./realTimeGender.vue?vue&type=style&index=0&id=47fd984a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd984a",
  null
  
)

export default component.exports